/** @module CostScenario/GroupMaterialCostsView */
define([
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/table/Widget",
	"./_GroupCostsMixin",
	"Specification/BOM/BOMSectionMixin"
], function(declare, ExtendedPath, Key, Widget, _GroupCostsMixin, BOMSectionMixin) {

	const COST_MATERIAL_TYPE = "CostMaterial";

	return declare([Widget, _GroupCostsMixin, BOMSectionMixin], {

		/**
		 * @override
		 * Default Material Costs Table View to Group by BOM Section
		 */
		onCreateDefaultCustomView(cv) {
			this.inherited(arguments);
			this.setDefaultGroupAndExpand("DSSection");
		},

		/**
		 * @override
		 * Intercept the query level creation if view is grouped to sort
		 * the items based on the cost scenario allsections updated from style bom
		 */
		_createQueryLevel: function(params, bRoot) {
			var ql = this.inherited(arguments);
			const extendedPath = new ExtendedPath(this.getDefaultCustomView().targetClass);
			const typedKey = new Key({ extendedPath, id: "DSSection"}).typedString;
			if (this.groupSettings && this.groupSettings.key1 === typedKey && params.type === COST_MATERIAL_TYPE) {
				var viewNode = this.getViewNode();
				var costScen = this.cacheView.get(viewNode?.__Parent__);
				if (costScen) {
					ql.groupDefaultsStore = this._getGroupDefaultsStore(costScen.AllSections, this.cacheView);
				}
			}

			return ql;
		}
	});
});